<template>
  <div>
    <h1 class="display-4">Editer un utilisateur : {{ user.first_name }} {{ user.last_name }}</h1>
    <hr />

    <b-form>
      <b-form-group label="Email" label-for="email" v-show="!id">
        <b-form-input id="email" placeholder="Email" v-model="user.email"></b-form-input>
      </b-form-group>
      <b-form-group label="Mot de passe" label-for="password" v-show="!id">
        <b-form-input id="password" placeholder="Mot de passe" type="password" v-model="user.password"></b-form-input>
      </b-form-group>
      <b-form-group label="Rôle" label-for="role">
        <b-form-select v-model="user.role" :options="roles"></b-form-select>
      </b-form-group>
      <b-form-group label="Prénom" label-for="FirstName">
        <b-form-input id="FirstName" placeholder="Prénom" v-model="user.first_name"></b-form-input>
      </b-form-group>
      <b-form-group label="Nom" label-for="LastName">
        <b-form-input id="LastName" placeholder="Nom" v-model="user.last_name"></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox id="Active" v-model="user.active">
          Actif
        </b-form-checkbox>
      </b-form-group>
      <b-form-group v-show="id">
        <label>Liste des établissements</label>
        <b-form-checkbox id="SelectAll" :checked="checkAll" @click.prevent="selectAll">
          Tout sélectionner
        </b-form-checkbox>
      </b-form-group>
      <b-form-group v-show="id">
        <b-form-checkbox-group
        id="checkbox-group-1"
        v-model="establishments_selected"
        :options="establishments"
        name="establishments"
        stacked
        ></b-form-checkbox-group>
      </b-form-group>
      <b-btn type="submit" variant="primary" @click.prevent="edit">Editer</b-btn>
      <router-link to="/users/list">
        <a class="btn btn-large btn-link">Revenir à la page précédente</a>
      </router-link>
    </b-form>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default {
  data () {
    return {
      checkAll: false,
      establishments: [],
      establishments_selected: [],
      previous_id: [],
      user: { role: 'user' },
      roles: [{ text: '--- Sélectionnez un rôle ---', value: '' }, 'admin', 'API', 'user']
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain']),
    id () {
      return this.$route.params.id
    }
  },
  methods: {
    edit () {
      if (this.id) {
        this.$http.post(this.domain + '/api/ionis/update?where[id]=' + this.id + '&access_token=' + this.access_token, { active: this.user.active, role: this.user.role, first_name: this.user.first_name, last_name: this.user.last_name }, { emulateJSON: true }).then((response) => {
          response.json().then((data) => {

          })
        }, (response) => {

        })
        for (let j = 0; j < this.previous_id.length; j++) {
          this.$http.delete(this.domain + '/api/establishments_ionis/' + this.previous_id[j] + '?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
            response.json().then((data) => {

            })
          }, (response) => {

          })
        }
        for (let i = 0; i < this.establishments_selected.length; i++) {
          this.$http.post(this.domain + '/api/establishments_ionis/replaceOrCreate?access_token=' + this.access_token, { establishmentId: this.establishments_selected[i], ionisId: this.id }, { emulateJSON: true }).then((response) => {
            response.json().then((data) => {
              if (response.status === 200 && response.ok) {
                this.$router.push('/users/list')
              }
            })
          }, (response) => {

          })
        }
      } else {
        this.$http.post(this.domain + '/api/ionis?access_token=' + this.access_token, { active: this.user.active, email: this.user.email, first_name: this.user.first_name, last_name: this.user.last_name, password: this.user.password, role: this.user.role }, { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            this.$router.push('/users/list')
          })
        }, (response) => {

        })
      }
    },
    selectAll () {
      this.checkAll = !this.checkAll
      this.establishments_selected = []
      if (this.checkAll) {
        for (let i = 0; i < this.establishments.length; i++) {
          this.establishments_selected.push(this.establishments[i].id)
        }
      }
    }
  },
  mounted () {
    if (this.id) {
      this.$http.get(this.domain + '/api/ionis/' + this.id + '?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.user = data
        })
      }, (response) => {

      })
      // Liste des établissements
      this.$http.get(this.domain + '/api/establishments?filter[include]=school&filter[include]=city&access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          // this.establishments = data
          for (let i = 0; i < data.length; i++) {
            this.establishments.push({
              text: data[i].school.name + ' ' + data[i].city.name,
              value: data[i].id
            })
          }
        })
      }, (response) => {

      })

      // Liste des établissements de l'utilisateur
      this.$http.get(this.domain + '/api/establishments_ionis?filter[where][ionisId]=' + this.id + '&access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          for (let i = 0; i < data.length; i++) {
            this.establishments_selected.push(data[i].establishmentId)
            this.previous_id.push(data[i].id)
          }
        })
      }, (response) => {

      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Users/Edit.vue